







































































import { Component, Vue, Provide, Prop } from "vue-property-decorator";
import { RobotCallRecordReq } from "@/pbjs/xcommon/dialer_pb";
import { dialerClient } from "@/api";
import { localGet, timeFormat } from "@/utils";
import { setCommon, errorMsg, handleResponse } from "@/utils/request";
import { pagnition } from "@/utils/commonConfig";
const mechinDetail = () => import("./components/mechinDetail.vue");

@Component({
  name: "RobotCallRecord",
  components: {
    mechinDetail,
  },
})
export default class CombinationProperty extends Vue {
  @Prop() private tableData: any;
  @Prop() private labelData: any;
  // @Prop() pageSize: any;  //分页页数
  @Prop() pagerCount: any; //总条数
  @Provide() private token: any = ""; // token
  @Provide() private pageSize: any = 20;
  @Provide() private openDetail: boolean = false;
  @Provide() private RobotCallDetail: any = "";
  @Provide() private pageIndex: any = 1; //当前页
  @Provide() private pagnition: any = pagnition;
  get tabledData() {
    return this.tableData;
  }

  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.$emit("autoCallTable", this.pageIndex, this.pageSize);
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.$emit("autoCallTable", this.pageIndex, this.pageSize);
    }
  }
  private openDetailBut(val: any) {
    // this.RobotCallDetail = val;
    this.openDetail = true;

    let request = new RobotCallRecordReq();
    request.setCommonin(setCommon());
    request.setId(val);
    dialerClient.getRobotCallRecord(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        this.RobotCallDetail = data.data;
      }
      if (err) {
        errorMsg(err);
      }
    });
  }
  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.$emit("autoCallTable", this.pageIndex, this.pageSize);
  }
  private hideManualUpgradeTicketDialogue(val: any) {
    this.openDetail = false;
  }
  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.$emit("autoCallTable", this.pageIndex, this.pageSize);
  }
}
